import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import HeaderDashboard from "../Components/Common/HeaderDashboard/HeaderDashboard";
import AppContext from "../Context/AppContext";

const AppRoute = ({
  component: Component,
  path,
  isPrivate,
  exact,
  ...rest
}) => {
  const { checkUserSession } = useContext(AppContext);
  return isPrivate ? (
    <>
      <HeaderDashboard />
      <div className="private__container">
        <Route
          exact={exact}
          path={path}
          render={(props) =>
            checkUserSession().bearer_token ? (
              <Component {...props} />
            ) : (
              <Redirect to={{ pathname: "/login" }} />
            )
          }
          {...rest}
        />
      </div>
    </>
  ) : (
    <Route
      exact={exact}
      path={path}
      render={(props) => <Component {...props} />}
      {...rest}
    />
  );
};

export default AppRoute;
